import script from "./OkrTimelinesTableHeadCell.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrTimelinesTableHeadCell.vue?vue&type=script&setup=true&lang=js"

import "./OkrTimelinesTableHeadCell.vue?vue&type=style&index=0&id=22fede54&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22fede54"]])

export default __exports__